module.exports = __webpack_public_path__ + "static/media/freemium.f0eef891.jpg";